import { useState, useContext } from "react";
import styled from "styled-components";
import ModalContext from "components/contexts/ModalContext";
import client from "api/WookAxios";
import { naver, kakao, google, authorize } from "auth/DeprecatedOAuth";
import naverOAuth from "images/naverLogoButton.png";
import kakaoOAuth from "images/kakao_oauth_large.png";
import googleOAuth from "images/google_oauth.svg";
import { AiOutlineClose } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { useAuth } from "auth/useAuth";
import { FaLess } from "react-icons/fa";
import UserContext from "user/UserContext";
import log, { error } from "loglevel";
import { CONFIG } from "config";
import { API_PATHS } from "constants/api";
import { OAUTH_PROVIDERS } from "constants/provider";
import { parseErrors } from "lib/errors/parse";
import { toast } from "sonner";
import { REGISTER_TOKEN } from "constants/auth";
import { REGISTER_PAGE } from "auth/register/constants";
import { Checker, CheckerBox } from "components/common/Mark";
import { PASSWORD_STRENGTH } from "constants/auth";
import { Indicator } from "components/common/Mark";
import zxcvbn from "zxcvbn";
import { FieldError } from "components/common/FieldError";
import { toastError } from "lib/toast";
import { IS_PROD } from "config/env";
import { PasswordInput } from "components/common/PasswordInput";

const ModalFrame = styled.div`
  // display: ${(props) => (props.$visible ? "flex" : "none")};
  // display: flex;
  // flex-direction: column;
  // justify-content: center;
  // align-items: center;
  position: fixed;
  top: 0px;
  width: 100%;
  height: 100%;
  background: rgb(45, 49, 45, 0.5);
  z-index: 1010;
`;

const Modal = styled.div`
  box-sizing: border-box;
  position: relative;
  top: 80px;
  display: flex;
  flex-direction: column;
  // justify-content: space-around;
  align-items: center;
  border-radius: 20px;
  width: 350px;
  height: 740px;
  margin: 0 auto;
  background: #fafbfa;
  background: white;
  opacity: 1;
`;

const Title = styled.div`
  // height: 40px;
  // background: red;
  width: 280px;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 30px;
  font-weight: 500;
  color: #464646;
  padding-top: 10px;
  padding-left: 10px;
`;

const StyledForm = styled.form`
  width: 280px;
  padding-bottom: 15px;
  // background: red;
`;

const Topic = styled.label`
  // background: lightpink;
  display: inline-block;
  margin-top: 8px;
  color: ${props => props.$disabled ? 'gray' : 'blue'};
  font-size: 14px;
`;
const StyledInput = styled.input`
  width: 98.5%;
  height: 28px;
  box-sizing: border;
  border-radius: 4px;
  border: none;
  margin-bottom: 0px;
  background: #eeeeee;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 15px;
  color: #363636;

  &::placeholder {
    color: black;
  }

  &:focus {
    color: black;
  }
`;

const StyledPasswordInput = styled(PasswordInput)`
  height: 28px;
`;

const StyledSubmit = styled.input`
  width: 100%;
  height: 40px;
  margin-top: 10px;
  border-radius: 4px;
  border: none;
  background: pink;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 15px;
  color: #363636;
`;

const Providers = styled.div`
  width: 280px;
  padding-top: 0px;
  // background: blue;
`;

const Provider = styled.div`
  display: flex;
  justify-content: left;
  border-radius: 4px;
  width: 100%;
  height: 40px;
  margin: 5px 0px;
  background: white;
  cursor: pointer;
  // border: 0.3px gray solid;
`;

const Naver = styled(Provider)`
  background: #03c75a;
`;

const Kakao = styled(Provider)`
  background: #ffe500;
`;

const Google = styled(Provider)`
  background: #f2f2f2;
`;

const Logo = styled.div`
  width: 40px;
  overflow: hidden;
`;

const Label = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding-right: 20px;
  font-size: 15px;
  // background: red;
`;

const StatusBar = styled.div`
  box-sizing: border-box;  
  width: 280px;
  padding-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
  display: flex;
  justify-content: space-between;
  // background: red;
`;

const TextButton = styled.div`
  color: blue;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 14px;
  &:hover {
    background: lightgray;
  }
`;

const REQUIRED_REGISTER_FIELDS = ['username', 'password', 'password2', 'name', 'email', 'mobile']

const RegisterModal = ({ registerData, fieldError, setFieldError, setRegisterData, onSuccess }) => {
  const { modalActions } = useContext(ModalContext);
  // const [fieldError, setFieldError] = useState({});
  const [password, setPassword] = useState('');
  const passwordScore = zxcvbn(password).score;
  const passwordStrength = PASSWORD_STRENGTH[passwordScore];
  const passwordState = ({
    length: password.length >= 8,
    alpha: /[A-Za-z]/.test(password),
    digit: /[0-9]/.test(password),
    special: /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/.test(password),
  });

  const navigate = useNavigate();

  const clearFieldError = (field) => {
    setFieldError(prev => {
      if (!prev[field]) return prev;

      const next = { ...prev };
      delete next[field];
      return next;
    });
  };

  const validateRegisterField = () => {
    const errors = {};
    
    REQUIRED_REGISTER_FIELDS.forEach(field => {
      if (!registerData[field].trim()) {
        errors[field] = '필수항목 입니다.';
      }
    });

    const usernameLen = registerData.username.length;
    if (registerData.username && (usernameLen < 4 || usernameLen > 20)) {
      errors.username = '4자 이상, 20자 이하만 사용가능합니다.';
    }

    const validUsername = /^[a-zA-Z0-9\.\_\+\@\-]+$/.test(registerData.username);
    if (registerData.username && !validUsername) {
      errors.username = '영문자, 숫자, 특수문자(. _ + - @)만 사용할수 있습니다.';
    }

    const validPassword = Object.values(passwordState).every(Boolean);
    if(!validPassword) {
      errors.password = '비밀번호 조건을 확인해 주세요.';
    }
    
    if (registerData.password !== registerData.password2) {
      errors.password2 = '비밀번호가 일치하지 않습니다';
    }

    const validEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(registerData.email);
    if (registerData.email && !validEmail) {
      errors.email = '잘못된 형식의 이메일 입니다.';
    }

    return Object.keys(errors).length > 0 ? errors : null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const errors = validateRegisterField();
    if (IS_PROD && errors) {
      setFieldError(errors);
      return;
    }
    
    onSuccess();
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setRegisterData(prev => ({...prev, [name]: value}));

    if (name === 'password') {
      setPassword(value);
      clearFieldError('password')
    }
  };

  const handleNaver = () => {
    window.location.href = API_PATHS.OAUTH_REGISTER(OAUTH_PROVIDERS.NAVER);
  };

  const handleKakao = () => {
    window.location.href = API_PATHS.OAUTH_REGISTER(OAUTH_PROVIDERS.KAKAO);
  };

  const handleGoogle = () => {
    window.location.href = API_PATHS.OAUTH_REGISTER(OAUTH_PROVIDERS.GOOGLE);
  };

  const handleLogin = () => {
    modalActions.openLogin();
  };

  const handleClose = () => {
    navigate('/');
  };

  const onTest2 = () => {
    const test2 = {
      username: 'test2',
      password: '1234',
      password2: '1234',
      name: '테스트2',
      email: 'a@abc.com',
      mobile: '010-1111-2222',
    };
    setRegisterData(test2);
    console.log(registerData);
  };

  return (
    <div className="RegisterModal">
      <ModalFrame>
        <Modal>
          <Title>회원가입</Title>
          
          <StyledForm onSubmit={handleSubmit}>
            <Topic>ID</Topic>
            <StyledInput 
              name="username"
              value={registerData.username}
              onChange={handleInputChange}
            />
            <FieldError message={fieldError.username} />
            
            <Topic>비밀번호</Topic>
            <Indicator score={passwordScore}>강도: {passwordStrength}</Indicator>
            <StyledPasswordInput
              name="password"
              value={registerData.password}
              onChange={handleInputChange}
            />
            <CheckerBox>
              조건
              <Checker ok={passwordState.length}>8자이상</Checker>
              <Checker ok={passwordState.alpha}>영문포함</Checker>
              <Checker ok={passwordState.digit}>숫자포함</Checker>
              <Checker ok={passwordState.special}>특수문자포함</Checker>
            </CheckerBox>
            <FieldError message={fieldError.password} />            

            <Topic>비밀번호확인</Topic>
            <StyledPasswordInput
              name="password2"
              value={registerData.password2}
              onChange={handleInputChange}
            />
            <FieldError message={fieldError.password2} />

            <Topic>이름</Topic>
            <StyledInput
              name="name"
              value={registerData.name}
              onChange={handleInputChange}
            />
            <FieldError message={fieldError.name} />

            <Topic>이메일</Topic>
            <StyledInput
              name="email"
              value={registerData.email}
              onChange={handleInputChange}
            />
            <FieldError message={fieldError.email} />

            <Topic>전화번호</Topic>
            <StyledInput
              name="mobile"
              value={registerData.mobile}
              onChange={handleInputChange}
            />
            <FieldError message={fieldError.mobile} />

            <StyledSubmit type="submit" value="회원가입" />
          </StyledForm>

          {process.env.NODE_ENV === 'development' && <button onClick={onTest2}>Test2</button>}
          
          <Providers>
            <Naver onClick={handleNaver}>
              <Logo><img src={naverOAuth} alt="naver" height="100%" /></Logo>
              <Label>네이버로 회원가입</Label>
            </Naver>
            <Kakao onClick={handleKakao}>
              <Logo><img src={kakaoOAuth} alt="kakao" height="100%" /></Logo>
              <Label>카카오로 회원가입</Label>
            </Kakao>
            <Google onClick={handleGoogle}>
              <Logo><img src={googleOAuth} alt="google" height="100%" /></Logo>
              <Label>Google로 회원가입</Label>
            </Google>
          </Providers>
          <StatusBar>
            <TextButton onClick={handleLogin}>로그인</TextButton>
            <TextButton onClick={handleClose}>취소</TextButton>
          </StatusBar>
        </Modal>
      </ModalFrame>
    </div>
  );
};

export default RegisterModal;
